import DocumentTitle from '~/components/DocumentTitle';
import { HeaderLogo } from '~/components/HeaderLogo';
import { withSessionRedirect } from '~/components/withSessionRedirect';
import { PLATFORMS } from '~/constants/platforms';
import { LoginScreen } from '~/screens/LoginScreen';

function Login() {
  return (
    <>
      <DocumentTitle>Login</DocumentTitle>
      <LoginScreen
        platform={PLATFORMS.foam}
        heading={<HeaderLogo platform={PLATFORMS.foam} heading="Log in" />}
      />
    </>
  );
}

export default withSessionRedirect(Login);
